import api from './api';

class ESignatureService {
  static async getESignatureRequests(params = {}) {
    try {
      const response = await api.get('/e-signatures', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching e-signature requests:', error);
      throw error;
    }
  }

  static async getESignatureRequestById(requestId) {
    try {
      const response = await api.get(`/e-signatures/${requestId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching e-signature request:', error);
      throw error;
    }
  }

  static async createESignatureRequest(requestData) {
    try {
      const response = await api.post('/e-signatures', requestData);
      return response.data;
    } catch (error) {
      console.error('Error creating e-signature request:', error);
      throw error;
    }
  }

  static async updateESignatureRequest(requestId, requestData) {
    try {
      const response = await api.put(`/e-signatures/${requestId}`, requestData);
      return response.data;
    } catch (error) {
      console.error('Error updating e-signature request:', error);
      throw error;
    }
  }

  static async deleteESignatureRequest(requestId) {
    try {
      const response = await api.delete(`/e-signatures/${requestId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting e-signature request:', error);
      throw error;
    }
  }

  static async sendESignatureRequest(requestId) {
    try {
      const response = await api.post(`/e-signatures/${requestId}/send`);
      return response.data;
    } catch (error) {
      console.error('Error sending e-signature request:', error);
      throw error;
    }
  }

  static async sendReminder(requestId, signerEmail = null) {
    try {
      const response = await api.post(`/e-signatures/${requestId}/remind`, {
        signerEmail
      });
      return response.data;
    } catch (error) {
      console.error('Error sending reminder:', error);
      throw error;
    }
  }

  static async recordSignature(requestId, signerEmail, signatureData = {}) {
    try {
      const response = await api.post(`/e-signatures/${requestId}/sign`, {
        signerEmail,
        signatureData
      });
      return response.data;
    } catch (error) {
      console.error('Error recording signature:', error);
      throw error;
    }
  }
}

export default ESignatureService;

